<template>
    <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>
<script>
export default {}
</script>

<style lang="scss">
@import '~ThemePath/scss/common/loading-button/index.scss';
</style>
